export class GcpWorkspaceInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpWorkspaceInfo.attributeTypeMap;
    }
    constructor() {
    }
}
